module.exports = __webpack_public_path__ + "static/img/Emily-Gielnik.293823c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Emily-Gielnik.jpg
// module id = 2+/F
// module chunks = 0